var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export const useNormalizeComposers = (composers) => composers.map((composer) => {
    const { companyComposers = [] } = composer, rest = __rest(composer, ["companyComposers"]);
    const isCompanyComposer = companyComposers !== null && companyComposers.length > 0;
    return Object.assign(Object.assign({}, rest), { isCompanyComposer });
});
